import React, { Component } from 'react'
import Lottie from 'react-lottie'
import animationData from '../../assets/lotties/loadLottie.json';


import animationData2 from '../../assets/lotties/89178-loading-spinner-simplui.json';

class lottieLoading extends Component {


    render() {

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };

        return (
            <div style={{ padding: "10px 0px 55px 10px" }}>
                < br />   < br />
                <Lottie options={defaultOptions}
                    height={400}
                    width={400}
                    isClickToPauseDisabled={true}
                />

                < br />     < br />
                <h1 style={{ textAlign: "center", padding: "0px 0px 55px 0px" }} >{this.props.text}</h1>
            </div>
        )
    }
}

export default lottieLoading